import { Inject } from '@odinjs/odin';

import { FieldAPI, FormAPI, InputAPI } from '@philips-emr/tws-components';
import Controller, { OnCancel, OnChange, OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { SubmittableFragmentContext } from '@philips-emr/tws-core/lib/component/context';
import { ChangeEvent, MountEvent, SubmitEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

@Controller({ fragment: 'solicitacoes-pendentes-informar-parecer' })
export default class SolicitacoesPendentesInformarParecerController extends BaseController {

  @Inject('SubmittableFragmentContext')
  private submittableFragmentContext: SubmittableFragmentContext;
  @Inject('input-aprovada')
  private inputAprovada: InputAPI;
  @Inject('field-aprovada')
  private fieldAprovada: FieldAPI;
  @Inject('form-informar-parecer')
  private formInformarParecer: FormAPI;

  @OnMount({ target: 'form-informar-parecer' })
  onMount(event: MountEvent): void {
    const api = event.target as FormAPI;
    const data = this.context.getBulkData().data as { qtSolicitada: number; qtAutorizada: string; situacao: Record<string, any> };

    if (data) {
      api.setRecord(data);
      this.inputAprovada.setMax(data.qtSolicitada);

      this.changeAprovada(data.situacao && data.situacao.cdSituacao === 'N', data.qtAutorizada);
    }
  }

  @OnSubmit({ target: 'form-informar-parecer' })
  onSubmit(event: SubmitEvent): void {
    const api = event.target as FormAPI;

    if (api.isValid()) {
      this.submittableFragmentContext.submit(event);
    }
  }

  @OnCancel({ target: 'form-informar-parecer' })
  onCancel(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

  @OnChange({ target: 'autocomplete-situacao' })
  onChangeAutocompleteSituacao(event: ChangeEvent<{ cdSituacao: string }>): void {
    const record = this.formInformarParecer.getRecord();
    const { qtAutorizada } = record;

    this.changeAprovada(event.value && event.value.cdSituacao === 'N', qtAutorizada as string);
  }

  private changeAprovada(isN: boolean, qtAutorizada: string): void {
    this.inputAprovada.setEnabled(!isN);
    if (isN) {
      this.fieldAprovada.setValue('0');
    } else if (String(qtAutorizada) === '0') {
      this.fieldAprovada.setValue('');
    }
  }
}
